/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { OrderViewModel } from './OrderViewModel'; 

export function getOrderOptions(orderId: string, onSuccess?: (result: OrderViewModel) => void) {
	return queryOptions({
		queryKey: ['order', orderId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/orders/queries/getorder/' + orderId;
			const resp = await axios.get<OrderViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(orderId)
	});
}